import { Edit, SimpleForm } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const transform = ({ name, section }) => ({ name, section });

const EditGoogleCourses = () => {
  return (
    <Edit
      title="Редакция на Google Зала"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
      transform={transform}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditGoogleCourses;
